import * as React from 'react';
import { PortalRenderer } from './PortalRenderer';
import { RegisteredDebug } from './components';
/**
 * Integrates the global portal renderer and the debug utilities
 * (if registered).
 */
export const PiralGlobals = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(PortalRenderer, { id: "root" }),
        React.createElement(RegisteredDebug, null)));
};
//# sourceMappingURL=PiralGlobals.js.map